import template from "./index.html";
import "./index.less";
import { sumBy } from "lodash";

export function controller() {
	const ctrl = this;

	ctrl.$onInit = () => {
		aggregateReportExports();
	};

	ctrl.$onChanges = () => {
		aggregateReportExports();
	};

	function aggregateReportExports() {
		const reports = ctrl.exportLog?.Reports ?? [];

		ctrl.totalReports = reports?.length ?? 0;
		ctrl.committed = sumBy(reports, r => r.IsCommitted ? 1 : 0);
		ctrl.suppressed = sumBy(reports, r => r.IsSuppressed ? 1 : 0);
		ctrl.errored = sumBy(reports, r => r.Errors?.length > 0 ? 1 : 0);
		ctrl.pending = ctrl.totalReports - ctrl.committed - ctrl.suppressed - ctrl.errored;
	}
}

export const informationTab = angular.module("vesl.components.exports.view-export.information-tab", [])
	.component("informationTab", {
		controller,
		template,
		bindings: {
			exportLog: "<"
		}
	})
	.name;
